import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    rootContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'flex-start',
        flex_shrink: '0',
        width: '100%',
        background_color: 'aqua',
        padding: `${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_250}`,
    },
    triggerContainer: {
        cursor: 'pointer',
        display: 'flex',
        flex_direction: 'row',
        width: '100%',
        align_items: 'stretch',
    },
    decorativeLine: {
        display: 'flex',
        width: FOUNDATIONS.size_50,
        background_color: FOUNDATIONS.color_comp_containers_accordionsection_border,
        border_radius: FOUNDATIONS.radius_150,
        margin_right: FOUNDATIONS.spacing_150,
    },
    title: {
        display: 'flex',
        text_align: 'left',
        font_variant: TextVariantType.FONT_TITLE_50,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    titleLeftIconContainer: {
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        column_gap: FOUNDATIONS.spacing_150,
    },
    titleTitleContentContainer: {
        display: 'flex',
        flex_direction: 'column',
        flex: 1,
        row_gap: FOUNDATIONS.spacing_100,
    },
    leftIcon: {
        width: FOUNDATIONS.spacing_300,
        height: FOUNDATIONS.spacing_300,
        color: FOUNDATIONS.color_neutral_icon_50,
    },
    rightIcon: {
        width: FOUNDATIONS.spacing_300,
        height: FOUNDATIONS.spacing_300,
        color: FOUNDATIONS.color_neutral_icon_50,
        transitionDuration: FOUNDATIONS.duration_175,
    },
    rightIconContainer: {
        margin_left: FOUNDATIONS.spacing_350,
    },
    contentContainer: {
        display: 'flex',
        width: '100%',
        margin_top: FOUNDATIONS.spacing_150,
    },
    expandibleContentContainer: {
        display: 'flex',
        width: '100%',
        margin_top: FOUNDATIONS.spacing_300,
    },
});
//# sourceMappingURL=commonStyles.js.map